<template>
  <ImportByFile
    :title="$t('forms.inputs.palletProduct')"
    :resource="$t('menu.products')"
    import_endpoint="pallet_products/import_file"
    :csv_xlsx="true"
    csv_model="pallet_products_upload.csv"
    xlsx_model="pallet_products_upload.xlsx"
    :params="this.$route.params.palletTypeId"
  />
</template>

<script>
import ImportByFile from '../shared/ImportByFile.vue'
export default {
  components: { ImportByFile },
}
</script>
